import React from 'react';
import { setMainHeader } from 'hb-redux-store/initial.action';
import { connect } from 'react-redux';
import { getBlogsByCategory } from 'hb-redux-store/feature/blog/blog.action';
import './blog.scss';
import Loader from '../../mweb/Skeletons/Loader/Loader';
import WebFooter from '../footer';
import MwebFooter from '../../mweb/Footer/Footer';
import BlogCard from '../../web/Blogs/BlogCard';
import { Link } from 'react-router-dom';
import { getDeviceType } from 'hb-redux-store/util/DeviceDetectionService';
import { DEVICE_TYPE } from 'hb-redux-store/util/constantServices';
import BlogNav from './BlogNav';
import Blogs from '../../mweb/Blogs/Blogs';

class BlogList extends React.Component {
  state = { activeCategoryIndex: 0 };
  componentDidMount() {
    const deviceType = getDeviceType();
    this.isDesktop = deviceType === DEVICE_TYPE.DESKTOP;
    if (this.isDesktop) this.props.setMainHeader(false);

    this.props.getBlogsByCategory();
  }

  componentWillUnmount() {
    if (this.isDesktop) this.props.setMainHeader(true);
  }

  getCategorySegment = segment => {
    const [firstBlog, secondBlog, thirdBlog] = segment.sectionTypeBlogsResponse;
    const segmentTitle = segment.header;
    const viewAll = segment.sectionTypeBlogsResponse?.length > 3;
    return (
      <div className="blog-list--segments" key={segment.blogSubcategoryId}>
        <div className="justify-content--space-between">
          <div className="blog-list--segments--title">{segmentTitle}</div>

          {viewAll && (
            <div className="blog-list--segments--view-all">
              <Link
                to={`/blogs/${segmentTitle}/${segment.blogSubcategoryId}`}
                className="button action-link more"
              >
                View All
              </Link>
            </div>
          )}
        </div>
        <BlogCard
          blog={firstBlog}
          source="category-pdp"
          width={secondBlog && !thirdBlog ? 'half' : 'full'}
        />
        {secondBlog && (
          <BlogCard blog={secondBlog} source="category-pdp" width="half" />
        )}
        {thirdBlog && (
          <BlogCard blog={thirdBlog} source="category-pdp" width="half" />
        )}
        <div className="section-divider" />
      </div>
    );
  };

  render() {
    const { loading, allBlogs, recentBlogs } = this.props;
    // console.log('Loading: ', loading);
    // console.log('allBlogs: ', allBlogs);
    const { activeCategoryIndex } = this.state;
    // console.log('log:', allBlogs?.length && allBlogs[activeCategoryIndex]);
    return (
      <div className="blog-list">
        {loading && <Loader />}
        {!loading && allBlogs && (
          <React.Fragment>
            {!this.isDesktop && <BlogNav />}
            <div className="blog-list--categories">
              {allBlogs.map((cat, index) => (
                <div
                  className={`blog-list--categories--category ${
                    activeCategoryIndex === index ? 'active' : ''
                  }`}
                  key={cat.blogCategoryId}
                  onClick={() => this.setState({ activeCategoryIndex: index })}
                >
                  {cat.header}
                </div>
              ))}
            </div>
            <div>
              <div className="blog-list--segment-blogs">
                {allBlogs[activeCategoryIndex]?.blogsSubCategoryResponse
                  ?.length > 0 &&
                  allBlogs[activeCategoryIndex]?.blogsSubCategoryResponse.map(
                    subCat => {
                      if (subCat.sectionTypeBlogsResponse?.length)
                        return this.getCategorySegment(subCat);
                    }
                  )}
              </div>
              {this.isDesktop && recentBlogs?.length > 0 && (
                <div className="blog-list--recent-post">
                  <div className="blog-list--recent-post--title">
                    Recent Post
                  </div>
                  {recentBlogs.map(blog => (
                    <BlogCard
                      blog={blog}
                      source="category-pdp"
                      key={blog.blogId}
                    />
                  ))}
                </div>
              )}
              {!this.isDesktop && recentBlogs?.length > 0 && (
                <React.Fragment>
                  <Blogs
                    blogs={recentBlogs}
                    title="Recent Post"
                    showViewAll={false}
                  />
                  <div className="section-divider" />
                </React.Fragment>
              )}
            </div>
            {this.isDesktop ? <WebFooter /> : <MwebFooter />}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ blogReducer }) => ({
  loading: blogReducer.loading,
  allBlogs: blogReducer.allBlogs,
  recentBlogs: blogReducer.recentBlogs,
});
const mapDispatchToProps = {
  setMainHeader,
  getBlogsByCategory,
};

export default connect(mapStateToProps, mapDispatchToProps)(BlogList);
